const chainReaderAddressMap: Record<string, Record<string, string>> = {
    'bnb': {
        'UniswapV3': '0x07Fd2185935C532059027B45Ae743b67a80DDF73',
        'PancakeSwapV3': '0x07Fd2185935C532059027B45Ae743b67a80DDF73',
        'UniswapV4': '0x77134eD4aCaDD5921B247f18C7d4ADE49a9a352d',
        'PancakeInfCl': '0x77134eD4aCaDD5921B247f18C7d4ADE49a9a352d',
    },
    'eth': {
        'UniswapV3': '0xc64eE5ded61C0EB02730aA73DEDfd5cb648Fb8Db',
        'PancakeSwapV3': '0xc64eE5ded61C0EB02730aA73DEDfd5cb648Fb8Db',
        'Aero': '0xc64eE5ded61C0EB02730aA73DEDfd5cb648Fb8Db',
        'UniswapV4': '0xFc89014Ed7357A9A289b479f29923e857cD4cBe0'
    },
    'base': {
        'UniswapV3': '0xcE686b21b5Cf4FF5eDe23Ca64de12CF62DCfc2b9',
        'PancakeSwapV3': '0xcE686b21b5Cf4FF5eDe23Ca64de12CF62DCfc2b9',
        'Aero': '0xcE686b21b5Cf4FF5eDe23Ca64de12CF62DCfc2b9',
        'UniswapV4': '0xBf348430b736cD4296Da097aC897fb910B941E63',
        'PancakeInfCl': '0xBf348430b736cD4296Da097aC897fb910B941E63',
    },
    'robinhood': {
        'UniswapV3': '0xbb9b1c58aDA5847DcF8F47f0D6f4039A27c18341',
        'Aero': '0xbb9b1c58aDA5847DcF8F47f0D6f4039A27c18341',
        'UniswapV4': '0xFc89014Ed7357A9A289b479f29923e857cD4cBe0',
    },
}

export default {
    getNodeUrl: function (chain: string) {
        switch (chain) {
            case 'bnb':
                return 'https://bsc-rpc.publicnode.com'
            case 'eth':
                return 'https://ethereum-rpc.publicnode.com'
            case 'base':
                return 'https://base-rpc.publicnode.com'
            case 'robinhood':
                return 'https://rpc.mainnet.chain.robinhood.com'
            default:
                throw new Error('Unsupported chain');
        }
    },
    getReaderAddress: function (chain: string, protocol: string): string {
        return chainReaderAddressMap[chain][protocol];
    },
    formatTick: function (tick: number, tickSpace: number) {
        return Math.floor(tick / tickSpace) * tickSpace;
    },
}
